import * as React from 'react';
import XSVG from '../svg/XSVG';

/**
 * Component for closing a toast.
 *
 * @class ToastClose
 * @extends {React.Component}
 */
class ToastClose extends React.Component {
	constructor(props) {
		super(props);
	}

	public render() {
		return (
			<div className="toast-close">
				<button className="toast-close__btn">
					<span className="visually-hidden">Close toast</span>
					<span className="toast-close__x">
						<XSVG class="toast-close__x-icon" />
					</span>
				</button>
			</div>
		);
	}
}

export default ToastClose;
